<template lang="pug">
    div(class="_row")
        slot
</template>

<script>
    /**
     * A row element in the grid layout system.
     * Row is horizontal group of columns to make sure it's lined up properly
     */
    export default {
        name: 'ib-row'
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._row {
        display: flex;
        flex: none;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: stretch;
        max-width: none;
        outline: 0;

        &.grow {
            flex: 1 1 auto;
        }
        &.shrink {
            flex: 0 1 auto;
        }
        &.grow,
        &.shrink {
            position: relative;
            max-height: 100%;
            overflow-x: hidden;
            overflow-y: auto;
            overflow-y: overlay;
            -webkit-overflow-scrolling: touch;
        }
    }
</style>

<docs>
    Only `ib-col` elements are allowed to be direct descendants of `ib-row`.

    #### Row Modifiers
    There are some modifier classes that can alter the behavior of row:

    ###### grow
    A grow row is a row that, when placed inside a flex column of fixed height, will
    always be the height of that column minus the heights of any sibling rows. If the
    content of the row doesn't require all the space be used, the row will still
    expand to occupy all the space. If the content is larger than the available space,
    the row will get a scrollbar. Basically switches flex 1 to 0, under the hood, for this row.

    ###### shrink
    A shrink row is like a grow row, but it can only
    shrink to get the scrollbar, it does not grow automatically to occupy all the
    available space. Basically switches flex 1 to 0, under the hood, for this row.

    Refer to [Grid Docs](/#!/Styles?id=grid) for overall grid layout information
</docs>
